import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, message, Row, Spin, Switch } from 'antd';
import MessageConfirmModal from '../messageModal/MessageConfirmModal';
import InputComponent from '../input/InputComponent';
import {useNavigate, useParams } from 'react-router-dom';
import { PRODUCT_CATEGORY_URL, PRODUCT_URL } from '../../api/URLs';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import SelectComponent from '../select/SelectComponent';
import DragUploadComponent from '../upload/DragUploadComponent';
import TextAreaComponent from '../input/TextAreaComponent';
import HeaderCreateStaffComponent from '../header/HeaderCreateStaffComponent';
import OSSUploadWrapper from '../upload/OSSUploadWrapper';
import MyRichTextEditor from '../RichTextEditor/MyRichTextEditor';

function NewProduct() {
    const { newStep } = useParams();
    const { t } = useTranslation();
    const { id } = useParams(); 
    const messageModalRef = useRef("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [categoryId, setCategoryId] = useState([])
    const [dataObject, setDataObject] = useState({
        name: "",
        images: [{ // multiple images
            url: "",
            size: "",
            name: ""
        }],
        description: "",
        categoryId: "", // product category _id
        price: null,
        status: true ,
        isFeature: false,
    });
    const [picUrl, setpicUrl] = useState([])

    const fetchCategory = async () => {
        return await getDataRequest(`${PRODUCT_CATEGORY_URL}`, {}).then((res) => {
            if (res.status === 200) {
                const datas = res?.data
                    ? res.data.map((it) => ({
                        label: it.name || "",
                        value: it._id, // ✅ only send _id as value
                    }))
                    : [];
                setCategoryId(datas);
            }
        });
    };
    useEffect(() => {
        fetchCategory()
    }, [])

    const addNewValue = async (data) => {
        setDataObject(
            {
                ...data,
                name: data.name || "",
                description: data.description || "",
                categoryId: data?.categoryId && data?.categoryId._id ? data?.categoryId._id : "", // product category _id
                price: data.price || "",
                status: data.status || "",
                isFeature: data.isFeature || false
            }
        )
        setpicUrl(data.images ?
            [
                {
                    name: data.images && data.images[0].name || "",
                    size: data.images && data.images[0].size || "",
                    url: data.images && data.images[0].url || "",
                }
            ]
            : [])
    }

    const getDetailById = async () => {
        try {
            setLoading(true);
            await getDataRequest(`${PRODUCT_URL}/${id && id}`)
                .then((res) => {
                    if (res.status === 200) {
                        addNewValue(res.data)
                    } 
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                });
        } catch (error) {
            setLoading(false);
            message.error('Server Error!');
        }
    }
    useEffect(() => {
        if (id && id) { getDetailById() }
    }, [newStep]);

    const checkError = () => {
        if (
            !dataObject.name ||
            picUrl && picUrl.length === 0 ||
            !dataObject.categoryId ||
            !dataObject.description ||
            !dataObject.price
        ) {
            return true
        }
        return false
    }
    const insertParams = () => {
        const productPayload = {
            name: dataObject.name,
            images: picUrl && picUrl.length > 0 ? picUrl[0].url : "",
            images: picUrl && picUrl.length > 0 ? [{
                url: picUrl && picUrl.length > 0 ? picUrl[0].url : "",
                size: picUrl && picUrl.length > 0 ? picUrl[0].size : "",
                name: picUrl && picUrl.length > 0 ? picUrl[0].name : "",
            }] : "",
            description: dataObject.description,
            categoryId: dataObject.categoryId, // product category _id
            price: dataObject.price,
            status: dataObject.status,
            isFeature: dataObject.isFeature
        }
        return productPayload
    }

    const hadleUpdateProduct = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        try {
            const productPayload = insertParams()
            if (checkError()) {
                return false;
            }
            setLoading(true);
            await putDataRequest(`${PRODUCT_URL}/${id && id} `, productPayload)
                .then((res) => {
                    if (res.status === 200) {
                        setLoading(false);
                        messageModalRef.current.showSuccessConfirmsAutoClose(t(res && res.message), () => { }, "", true);
                        setTimeout(() => {
                            navigate("/product")
                        }, 2000);
                    } else {
                        messageModalRef.current.showWarningConfirmsAutoClose(res && t(res.message), () => { }, "", true);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                    messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && t(err.response.data.message )|| `Server Error!`, () => { }, "", true);
                });
        } catch (error) {
            console.log("error", error)
            setLoading(false);
            message.error('Server Error!');
        }
    }

    // Save member
    const handleSubmit = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setLoading(true);
        const productPayload = insertParams()
        try {
            const res = await postDataRequest(PRODUCT_URL, productPayload);
            if (res?.status === 200) {
                messageModalRef.current.showSuccessConfirmsAutoClose(t(res && res.data?.message) || t("Saved Successfully"), () => { }, "", true);
                setTimeout(() => {
                    navigate("/product")
                }, 2000);
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res && t(res.data?.message) || t(res.message )|| t("An error occurred."), () => { }, "", true);
            }
        } catch (err) {
            messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && t(err.response.data.message )|| `Server Error!`, () => { }, "", true);
        } finally {
            setLoading(false);
            setIsSubmit(false);
        }
    }


    return (
        <>
            <HeaderCreateStaffComponent
                bntTitle={<>
                    <Button
                        className='b-danger'
                        disabled={loading}
                        type="primary"
                        onClick={id ? hadleUpdateProduct : handleSubmit}
                        style={{
                            fontSize: '16px',
                            backgroundColor: "#E50A47",
                            border: "1px solid #e72158",
                            color: "#FFFFFF",
                            opacity: loading ? '0.4' : ""
                        }}
                        danger
                    >
                        {id ? t("Submit") : t(`Submit`)}
                    </Button>
                </>}
                isHide="view"
                onClick={() => {
                    navigate('/product')
                }}
                backTitle={t('Create Product')}
            >
                <Spin spinning={loading}>
                    {
                        !newStep || newStep - 0 === 1 ? <div className='container newDetail'>
                            <Row className='mb-5'>
                                <Col md={4}>{t("Product Photo")} :</Col>
                                <Col md={20}>
                                    <Row className='w-100'>
                                        <Col md={24} sm={24}>
                                            <div className='w-100'>
                                                <OSSUploadWrapper
                                                    onUploadSuccess={(value) => {
                                                        setpicUrl([value]);
                                                    }}
                                                >
                                                    <DragUploadComponent
                                                        fileList={picUrl ? picUrl : []}
                                                        setFileList={(values) => {
                                                            setpicUrl(values)
                                                        }}
                                                    />
                                                </OSSUploadWrapper>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Product Name")} :</Col>
                                <Col md={20}>
                                    <InputComponent className={`mb-2`} status={isSubmit && !dataObject.name && `error`} value={dataObject.name}
                                        setValue={(value) => setDataObject({ ...dataObject, name: value })} placeholder="" />
                                </Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Product Category")} :</Col>
                                <Col md={20}>
                                    <SelectComponent
                                        options={categoryId}
                                        value={dataObject.categoryId}
                                        setValue={(value) => setDataObject((v) => ({ ...v, categoryId: value }))}
                                        status={isSubmit && !dataObject.categoryId && "error"}
                                        placeholder=""
                                    />

                                </Col>
                            </Row>
                            {/* <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Product Introduction")} :</Col>
                                <Col md={20}>
                                    <TextAreaComponent className={`mb-2`} status={isSubmit && !dataObject.description && `error`} value={dataObject.description}
                                        setValue={(value) => setDataObject({ ...dataObject, description: value })} placeholder="" />
                                </Col>
                            </Row> */}
                            <Row className='d-flex align-items-center mt-4'>
                                <Col md={4}>{t("Product Price")} :</Col>
                                <Col md={10}>
                                    <InputComponent
                                        type="number"
                                        className={`mb-2`}
                                        status={isSubmit && !dataObject.price && `error`}
                                        value={dataObject.price}
                                        setValue={(value) => setDataObject({ ...dataObject, price: value })}
                                        placeholder=""
                                    />
                                </Col>
                                <Col md={4}><span style={{ color: "#636e88", marginLeft: "1rem" }}>{t("yuan")}</span></Col>
                            </Row>
                            <Row className='mt-4 d-flex align-items-center'>
                                <Col md={4}>{t("Feature")} :</Col>
                                <Col md={20} className='d-flex align-items-center' style={{ gap: "12px" }}>
                                    <Switch
                                        onChange={(value) => {
                                            setDataObject((v) => ({ ...v, isFeature: value }));
                                        }}
                                        checked={!!dataObject?.isFeature}
                                    />
                                    <span style={{ color: "#8c8c8c", fontSize: "13px" }}>
                                        {t("(Up to 4 special products will be displayed at the top)")}
                                    </span>
                                </Col>
                            </Row>
                            <Row className='mt-4 mb-4 d-flex align-items-start'>
                                <Col md={24}>{t("Product Introduction")} :</Col>
                                <Col md={24} className='mt-2'>
                                    <div style={{ border: isSubmit && !dataObject.description ? '1px solid #ff4d4f' : '1px solid #d9d9d9', borderRadius: '4px' }}>
                                        <MyRichTextEditor
                                            value={dataObject.description}
                                            onChange={(htmlContent) => setDataObject((prev) => ({ ...prev, description: htmlContent }))}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                            :
                            ""
                    }
                    <MessageConfirmModal textCentered ref={messageModalRef} />
                </Spin>
            </HeaderCreateStaffComponent>
        </>
    );
}

export default NewProduct;
